import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@mui/material/Tooltip";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import PropTypes from "prop-types";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// const windows = [
//   {
//     id: 1,
//     name: "IIS",
//     value: "iis",
//   },
//   {
//     id: 2,
//     name: "Java",
//     value: "java",
//   },
//   {
//     id: 3,
//     name: "Java Eclipse",
//     value: "java_eclipse",
//   },
//   {
//     id: 4,
//     name: "Mssql Server Express",
//     value: "mssql_express",
//   },
//   {
//     id: 5,
//     name: "Mssql Server Studio",
//     value: "mssql_studio",
//   },
//   {
//     id: 6,
//     name: "Notepad ++",
//     value: "notepad",
//   },
//   {
//     id: 7,
//     name: "Php",
//     value: "php",
//   },
//   {
//     id: 8,
//     name: "Powershell",
//     value: "powershell",
//   },
//   {
//     id: 9,
//     name: "Python",
//     value: "python",
//   },
//   {
//     id: 10,
//     name: "Ruby",
//     value: "ruby",
//   },
//   {
//     id: 11,
//     name: "Terraform",
//     value: "terraform",
//   },
//   {
//     id: 12,
//     name: "Visual Studio",
//     value: "visual_studio",
//   },
//   {
//     id: 13,
//     name: "VS Code",
//     value: "vs_code",
//   },
// ];

// const linux = [
//   {
//     id: 1,
//     name: "Apache",
//     value: "apache",
//   },
//   {
//     id: 2,
//     name: "Java",
//     value: "java",
//   },
//   {
//     id: 3,
//     name: "MariaDB",
//     value: "mariadb",
//   },
//   {
//     id: 4,
//     name: "Mysql",
//     value: "mysql",
//   },
//   {
//     id: 5,
//     name: "Nginx",
//     value: "nginx",
//   },
//   {
//     id: 6,
//     name: "NodeJs",
//     value: "nodejs",
//   },
//   {
//     id: 7,
//     name: "Php",
//     value: "php",
//   },
//   {
//     id: 8,
//     name: "Python",
//     value: "python",
//   },
//   {
//     id: 9,
//     name: "Ruby",
//     value: "ruby",
//   },
//   {
//     id: 10,
//     name: "Terraform",
//     value: "terraform",
//   },
// ];

function ContentProcessing(props) {
  const { array, Delete } = props;
  return (
    <>
      {array.map((row) => (
        <TableRow key={row.name}>
          <TableCell align="center">{row.id}</TableCell>
          <TableCell align="center">{row.name}</TableCell>
          <TableCell align="center">
            <Tooltip title="Remove" arrow>
              <IconButton aria-label="delete" onClick={Delete(row.userlab)} sx={{ borderRadius: '50px' }}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
export default function CustomizedDialogs(props) {
  const { groups, user_id } = props;

  const [open, setOpen] = React.useState(false);

  const [allocatedlabslist, setAllocatedlabslist] = useState([]);
  const handleClickOpen = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/api/userallocated/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setAllocatedlabslist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Delete = (userID) => {
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/removeallocated/${userID}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log(error);
        });
      fetch(`${process.env.REACT_APP_API_URL}/api/userallocated/${user_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((resp) => setAllocatedlabslist(resp))
        .catch((error) => {
          console.error(error);
          window.location.href = "/something_went_wrong";
        });
    };
  };

  return (
    <div>
      <Tooltip title="View Assigned Labs" arrow>
        <span>
          <IconButton
            aria-label="View"
            disabled={groups[0] === 4 ? false : true}
            onClick={handleClickOpen}
            sx={{ borderRadius: '50px' }}
          >
            <InfoIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Dialog
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <MuiDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Allocated Labs
        </MuiDialogTitle>
        <MuiDialogContent
          dividers
          style={{ textAlignLast: "center", width: 800 }}
        >
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                style={
                  value == 0
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Preconfigured"
                {...a11yProps(0)}
              />
              <Tab
                style={
                  value == 1
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Custom"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 2
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Hypervised"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 3
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Shared"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 4
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Cloud"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 5
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Wise"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 6
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="Manual"
                {...a11yProps(1)}
              />
              <Tab
                style={
                  value == 7
                    ? { color: "#ffffff", backgroundColor: "rgb(0, 30, 60)" }
                    : { color: "aliceblue" }
                }
                label="SaaS"
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["prearray"] &&
                    allocatedlabslist["prearray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["prearray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["customarray"] &&
                    allocatedlabslist["customarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["customarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["hypervmarray"] &&
                    allocatedlabslist["hypervmarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["hypervmarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["sharedvmarray"] &&
                    allocatedlabslist["sharedvmarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["sharedvmarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["cloudarray"] &&
                    allocatedlabslist["cloudarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["cloudarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={5}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["wisearray"] &&
                    allocatedlabslist["wisearray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["wisearray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={6}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["manualarray"] &&
                    allocatedlabslist["manualarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["manualarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={7}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S/N</TableCell>
                    <TableCell align="center">Lab Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allocatedlabslist["sasarray"] &&
                    allocatedlabslist["sasarray"].length > 0 ? (
                    <ContentProcessing
                      array={allocatedlabslist["sasarray"]}
                      Delete={Delete}
                    />
                  ) : (
                    <React.Fragment>
                      <TableRow>
                        <TableCell align="center"></TableCell>
                        <TableCell align="center">
                          --- No labs available ---
                        </TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
        </MuiDialogContent>

        <MuiDialogActions>
          <Tooltip title="Close" arrow>
            <Button
              size="small"
              variant="contained"
              style={{ marginLeft: "10px" }}
              color="primary"
              onClick={handleClose}
              sx={{ borderRadius: '50px', px: 3, py: 1 }}
            >
              Close
            </Button>
          </Tooltip>
        </MuiDialogActions>
      </Dialog>
    </div>
  );
}
